import { useTranslation } from "react-i18next";
import type { JsonObject } from "../../api/http/jsonDecoding";
import { itemLifecycle, type LifecycleState } from "./itemLifecycle";
import ReplacementLine from "./ReplacementLine";
import Chip from "../../ui/feedback/Chip";

const NOTES: Readonly<Partial<Record<LifecycleState, string>>> = {
  deprecated: "reviews.lifecycle.deprecatedNote",
  retired: "reviews.lifecycle.retiredNote",
  withdrawn: "reviews.lifecycle.withdrawnNote",
};

/** The lifecycle state of a process item: a chip, and for deprecated, retired and
 * withdrawn items what that means, why, and what replaces it (process-governance.md PG-6).
 * Active, the normal case, needs no chip. */
export default function ItemLifecycleBadge({ projectId, definition }: { projectId: string | null; definition: JsonObject | null }) {
  const { t } = useTranslation();
  const lifecycle = itemLifecycle(definition);
  if (lifecycle === null || lifecycle.state === "active") {
    return null;
  }
  const note = NOTES[lifecycle.state];
  return (
    <div className="space-y-0.5 text-xs" data-lifecycle={lifecycle.state}>
      <p><Chip className={note === undefined ? undefined : "font-semibold"}>{t(`reviews.lifecycle.state.${lifecycle.state}`)}</Chip></p>
      {note === undefined ? null : <p className="app-text-muted">{t(note)}</p>}
      {lifecycle.reason !== null ? <p className="app-text-muted">{t("reviews.lifecycle.reason", { reason: lifecycle.reason })}</p> : null}
      {lifecycle.replacedBy === "none" ? <p className="app-text-muted">{t("reviews.lifecycle.noReplacement")}</p> : null}
      {lifecycle.replacedBy !== null && lifecycle.replacedBy !== "none" ? (
        <ReplacementLine projectId={projectId} itemId={lifecycle.replacedBy} />
      ) : null}
    </div>
  );
}
